<template>
    <billing-layout>
         <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Setting</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-center justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                   
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">
                <div class="card">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card card-body">  
                <div class="list-group list-group-flush">
                    <h4>GENERAL SETTING</h4>
                    <router-link :to="{name: 'SettingCompanyInfo'}" class="list-group-item list-group-item-action">Organization Information</router-link>
                    <router-link :to="{name: 'Settingeprint'}" class="list-group-item list-group-item-action">ePrint Setup</router-link>
                    <router-link :to="{name: 'RestoreCustomer'}" class="list-group-item list-group-item-action">Restore</router-link>
                    <router-link :to="{name: 'Backgrounds'}" class="list-group-item list-group-item-action">Backgrounds</router-link>
                </div>
                    </div>
                    </div>
                    <div class="col-md-3">
                    <div class="card card-body">  
                <div class="list-group list-group-flush">
                    <h4>MONEY IN</h4>
                    <router-link :to="'setting/taxes'" class="list-group-item list-group-item-action">Tax</router-link>
                    <router-link :to="'setting/terms'" class="list-group-item list-group-item-action">Terms</router-link>
                    <router-link :to="'setting/product-services'" class="list-group-item list-group-item-action">Product & Services</router-link>
                    <router-link :to="'setting/chart-accounts'" class="list-group-item list-group-item-action">Chart of Accounts</router-link>
                </div>
                    </div>
                    </div>

                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>MONEY OUT</h4>
                        <!-- <a href="#" class="list-group-item list-group-item-action">Expenses</a> -->
                        <router-link :to="{name: 'EmailMessageStatement'}" class="list-group-item list-group-item-action">Payment Received Message</router-link>
                    </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>ESTIMATE SETTING</h4>
                        <router-link :to="'setting/contract-templates'" class="list-group-item list-group-item-action">Contract Templates</router-link>
                        <router-link :to="{name: 'EmailMessageEstimate'}" class="list-group-item list-group-item-action">Email Messages</router-link>
                        <div class="list-group-item list-group-item-action" @click="SettingBox = 'StartEstimate'">Start Number</div>
                        <div class="list-group-item list-group-item-action" @click="SettingBox = 'ShowPDFOptionsEsti'">Show PDF Options</div>
                    </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>INVOICE SETTING</h4>
                        <div class="list-group-item list-group-item-action" @click="SettingBox = 'StartInvoice'">Start Number</div>
                        <router-link :to="{name: 'EmailMessageInvoice'}" class="list-group-item list-group-item-action">Email Messages</router-link>
                        <router-link :to="{name: 'EmailMessageInvVoid'}" class="list-group-item list-group-item-action">Email Messages Void</router-link>
                        <div class="list-group-item list-group-item-action" @click="SettingBox = 'ShowPDFOptionsInvo'">Show PDF Options</div>

                    </div>
                    </div>
                </div>
                    </div>
                </div>
              </div>
            </div>
        </div>


  <modal name="modal-setting"  height="auto" @before-close="ClosedModal">
    <div class="card">
        <button @click="closeModal" class="closeIcon"><span></span></button>
    <component :is="SettingBox"></component>
    </div>
</modal>
    </billing-layout>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import Taxes from '@/components/billing/setting/Taxes.vue';
import Terms from '@/components/billing/setting/Terms.vue';
import StartInvoice from '@/components/billing/setting/StartInvoice.vue';
import StartEstimate from '@/components/billing/setting/StartEstimate.vue';
import ShowPDFOptionsInvo from '@/components/billing/setting/ShowPDFOptionsInvo.vue';
import ShowPDFOptionsEsti from '@/components/billing/setting/ShowPDFOptionsEsti.vue';
import EventBus from '@/eventBus';
export default {
     name:'Setting',
    components:{
            Loader,
            BillingLayout,
            Terms,
            Taxes,
            StartInvoice,
            StartEstimate,
            ShowPDFOptionsInvo,
            ShowPDFOptionsEsti,
    },
    data() {
        return{
           showModal: false,
           SettingBox : ''
        } 
    },
    mounted(){
        //this.getStates()
        EventBus.$on('UpdateOk', data => {
            this.ClosedModal();
            this.closeModal();
        });
        EventBus.$on('UpdateStartInvoice', data => {
           this.ClosedModal();
            this.closeModal();
        });
        EventBus.$on('UpdateStartEstimate', data => {
            this.ClosedModal();
            this.closeModal();
        });
        EventBus.$on('UpdateShowPDFOptionsInvo', data => {
            this.ClosedModal();
            this.closeModal();
        });
        EventBus.$on('UpdateShowPDFOptionsEsti', data => {
            this.ClosedModal();
            this.closeModal();
        });
    },
    methods:{
        closeModal(){
        this.$modal.hide('modal-setting')
        },
        ClosedModal(){
            EventBus.$off(this.SettingBox);
            this.SettingBox ='';
        },
        getStatesxxx() {
              this.isLoadingCustomers = true
            window.billing.get('states/')
                .then((response) => {
					 console.log(response.data.resultStates)         
                    this.CustomersList = response.data.resultStates;
					this.isLoadingCustomers = false
                }).catch((error) => console.log(error));
        },

        
    },
    watch:{
        SettingBox: function (){
            if(!this.SettingBox ==''){
             this.$modal.show('modal-setting');
            }
        }
    }
};
</script>
<style lang="scss">
i.fas.fa-arrow-left {
    font-size: 13px;
}

</style>
